<div class="email-templates-container">
    <h2>Email Templates</h2>

    <!-- Email Templates Table -->
    <div *ngIf="emailTemplates.length > 0" class="templates-table">
        <table class="table table-bordered">
            <thead>
                <tr>
                    <th>Template Key</th>
                    <th>Header</th>
                    <th>Actions</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let template of emailTemplates">
                    <td>{{ template.templateKey }}</td>
                    <td>{{ template.header }}</td>
                    <td>
                        <button class="btn btn-primary" (click)="selectTemplate(template)">
                Edit
              </button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <!-- Empty State -->
    <div *ngIf="emailTemplates.length === 0" class="empty-state">
        <p>No email templates available. Please check back later.</p>
    </div>

    <!-- Selected Template Editor -->
    <div *ngIf="selectedTemplate" class="template-editor">
        <h3>Edit Template: {{ selectedTemplate.templateKey }}</h3>

        <!-- Template Keys Section -->
        <div *ngIf="templateKeys.length > 0" class="template-keys">
            <h4>Available Keys</h4>
            <ul>
                <li *ngFor="let key of templateKeys" class="key-item" (click)="insertKeyAtCursor(key.replacementKey)">
                    {{ key.replacementKey }}
                </li>
            </ul>
        </div>

        <form (ngSubmit)="updateEmailTemplate(selectedTemplate)">
            <!-- Header Section -->
            <div class="form-group">
                <label for="header">Header</label>
                <div id="header" class="editable" contenteditable="true" (click)="setCursorField('header')">
                    <ng-container *ngFor="let block of headerBlocks">
                        <span *ngIf="block.type === 'text'">{{ block.content }}</span>
                        <span *ngIf="block.type === 'key'" class="key-block" contenteditable="false" (dblclick)="removeKey($event.target)">
                {{ block.content }}
              </span>
                    </ng-container>
                </div>
            </div>

            <!-- Body Content Section -->
            <div class="form-group">
                <label for="bodyContent">Body Content</label>
                <div id="bodyContent" class="editable" contenteditable="true" (click)="setCursorField('bodyContent')">
                    <ng-container *ngFor="let block of bodyBlocks">
                        <span *ngIf="block.type === 'text'">{{ block.content }}</span>
                        <span *ngIf="block.type === 'key'" class="key-block" contenteditable="false" (dblclick)="removeKey($event.target)">
                {{ block.content }}
              </span>
                    </ng-container>
                </div>
            </div>

            <!-- Form Actions -->
            <div class="form-actions">
                <button type="submit" class="btn btn-success" style="margin-right: 10px;">Save</button>
                <button type="button" class="btn btn-secondary" (click)="selectedTemplate = null" style="margin-right: 10px;">Cancel</button>
                <button type="button" class="btn btn-info" (click)="testEmailTemplate()">Test</button>
            </div>


        </form>
    </div>
</div>